// extracted by mini-css-extract-plugin
export default {"alerts":"PatientAlerts_alerts__Pt6pm","flag":"PatientAlerts_flag__MGsMd"};